module.exports = __webpack_public_path__ + "img/sol.4a167ad9.svg";